var ContentServerAssetLoader = require("./contentServerAssetLoader.js");
var inherit = require("./src/general.js").inherit;

/**
 * DummyAssetLoader provides dummy assets.
 */
var DummyAssetLoader = function (dataManager, config) {
    ContentServerAssetLoader.call(this, dataManager, config);
};
inherit(DummyAssetLoader, ContentServerAssetLoader);

module.exports = DummyAssetLoader;
